var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTicketLine = function SvgTicketLine(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 339,
    viewBox: "0 0 40 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ticket-line_svg__clip0_1384_3667)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 339,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    r: 20,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 34,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 52,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 70,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 88,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 106,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 124,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 142,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 160,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 178,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 196,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 214,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 232,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 250,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 268,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 286,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 304,
    r: 4,
    fill: "#F4EADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 339,
    r: 20,
    fill: "#F4EADA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ticket-line_svg__clip0_1384_3667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 339,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTicketLine);
export default ForwardRef;